import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

interface SelectedAndUnselectdListingIF {
  data: any;
  selectedItem: any;
  onSelectHandler: any;
  selectColor: string;
  unselectedColor: string;
  unselectedTextColor: string;
  fontSize?: string;
}
const MainDiv = styled<any>("div")`
  display: flex;
  gap: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "16px" : "24px"};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? "0px 16px 12px 16px"
      : "0px 0px 12px 0px"};
  padding-bottom: 12px;
  overflow: auto;
  ::-webkit-scrollbar {
    height: 0px !important;
  }
`;
const ListingFilterDiv = styled<any>("div")`
  width: fit-content;
  display: flex;
  gap: 2px; //
  flex-direction: row;
  border-radius: 4px;
  align-items: center;
  padding: ${({ fontSize }: any) => (fontSize ? "8px" : "4px")};
  cursor: pointer;
  color: ${({ isSelected, unselectedTextColor, unselectedColor }: any) =>
    isSelected ? unselectedColor : unselectedTextColor};
  font-size: ${({ fontSize }: any) => (fontSize ? fontSize : "12px")};
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  background: ${({ isSelected, selectColor, unselectedColor }: any) =>
    isSelected ? selectColor : unselectedColor};
`;
const NameSpan = styled<any>("span")`
  white-space: nowwrap;
`;
const CountSpan = styled<any>("span")`
  white-space: nowwrap;
`;

const SelectedAndUnselectdListing = ({
  data,
  selectedItem,
  onSelectHandler,
  selectColor,
  unselectedColor,
  unselectedTextColor,
  fontSize,
}: SelectedAndUnselectdListingIF) => {
  const { screen }: any = useWindowSize();
  return (
    <MainDiv screen={screen}>
      {data &&
        Array.isArray(data) &&
        data.map((ele: any, index: number) => {
          return (
            <ListingFilter
              key={ele + index}
              ele={ele}
              count={data[ele]}
              isSelected={selectedItem === ele?.value}
              onSelectHandler={onSelectHandler}
              selectColor={selectColor}
              unselectedColor={unselectedColor}
              unselectedTextColor={unselectedTextColor}
              fontSize={fontSize}
            >
              {ele + index}
            </ListingFilter>
          );
        })}
    </MainDiv>
  );
};
export default SelectedAndUnselectdListing;

export const ListingFilter = ({
  ele,
  count,
  isSelected,
  onSelectHandler,
  selectColor,
  unselectedColor,
  unselectedTextColor,
  fontSize,
}: any) => {
  return (
    <ListingFilterDiv
      isSelected={isSelected}
      selectColor={selectColor}
      unselectedColor={unselectedColor}
      unselectedTextColor={unselectedTextColor}
      fontSize={fontSize}
      onClick={() => {
        onSelectHandler(ele?.value);
      }}
    >
      <NameSpan>{count ? ele?.value + ":" : ele?.value} </NameSpan>
      {count && <CountSpan>{count}</CountSpan>}
    </ListingFilterDiv>
  );
};
